import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Card, DataListItem } from '@node-space/ui-components'
import { CustomerDetails } from '../types'

interface CustomerInfoProps {
  customerDetails: CustomerDetails
}

const CustomerInfo = ({ customerDetails }: CustomerInfoProps) => {
  const { t } = useTranslation()

  return (
    <Card variant="static" emphasis full>
      <Box flex isFlexWrap gapX={24} gapY={16} className="w-full">
        {customerDetails?.details &&
          Object.keys(customerDetails?.details)
            ?.filter(key => !!customerDetails?.details?.[key]?.trim())
            ?.map(key => (
              <Box key={`${customerDetails?.name}-${key}`} className="min-w-40 flex-1">
                <DataListItem
                  id={`${customerDetails?.name}-${key}`}
                  title={t(`customers.${key}`)}
                  body={customerDetails?.details?.[key]}
                  layout="vertical"
                />
              </Box>
            ))}
      </Box>
    </Card>
  )
}

export default CustomerInfo
